  var skin_quiz_recomendation = [];
    var skin_quiz_recomendation_arr = {};
    var skin_quiz_recomendation_sku = {};
  
    var option_selected_alphabets_rec_arr=[];
    var option_selected_alphabets_arr=[];

      var option_custom_msg_arr=[];


    var option_selected_sku={};

function calculateElementFrequency(array)
{
    const o = {};

array.forEach(item => {
    o[item] = (o[item] || 0) + 1;
});
  return o

}

  function modeArray(array) {
  if (array.length == 0) return null;
  var modeMap = {},
    maxCount = 1,
    modes = [];

  for (var i = 0; i < array.length; i++) {
    var el = array[i];

    if (modeMap[el] == null) modeMap[el] = 1;
    else modeMap[el]++;

    if (modeMap[el] > maxCount) {
      modes = [el];
      maxCount = modeMap[el];
    } else if (modeMap[el] == maxCount) {
      modes.push(el);
      maxCount = modeMap[el];
    }
  }
  return modes;
}

    function nailQuiz(initial_bg_image) {
        $(".start_quiz").click(function (event) {
            
             });
      $(this).parent().parent().parent().parent().hide();
           if (!$('#shopify-section-template--15305229402192__main').hasClass('quiz_section_show_image')) {
                $('#shopify-section-template--15305229402192__main').addClass('quiz_section_show_image');
            }

          var bg_image=$('.question_wrap:first').attr('data-bg');
                     bg_image =initial_bg_image;

        var bg_img_url='https://cdn.shopify.com/s/files/1/0550/8926/6768/files/'+bg_image;
        $('.quiz_section_show_image').css('background-image', 'url(' + bg_img_url + ')');

            $('.quiz_wrap').show();
            adjust_height();


       
        $(".start_pre_quiz").click(function (event) {
            var input_el = $(this).parent().find('input');
            var error = 0;
            var email_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
            $(input_el).each(function () {
                if ($(this).hasClass('is_required_field')) {
                    var field_type = $(this).attr('type');
                    if (field_type == 'text') {
                        if (!$(this).hasClass('email')) {
                            if ($(this).val() == '') {
                                error = 1;
                                $(this).next().html('This field is required');
                                $(this).next().show();
                            } else {
                                $(this).next().html('');
                                $(this).next().hide();
                            }
                        } else {
                            if ($(this).val() == '') {
                                error = 1;
                                $(this).next().html('This field is required');
                                $(this).next().show();
                            } else {
                                if (!email_pattern.test($(this).val())) {
                                    error = 1;
                                    $(this).next().html('Please enter a valid email');
                                    $(this).next().show();
                                } else {
                                    $(this).next().html('');
                                    $(this).next().hide();
                                }
                            }
                        }
                    }
                }
            });
            if (error == 0) {
                $(this).parent().hide();
            }
        });
    }
    function validateSkinQuizContact(el) {
        var input_el = $(el).parent().find('input');
        var error = 0;
        var email_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
        $(input_el).each(function () {
            if ($(this).hasClass('is_required_field')) {
                var field_type = $(this).attr('type');
                if (field_type == 'text') {
                    if (!$(this).hasClass('email')) {
                        if ($(this).val() == '') {
                            error = 1;
                            $(this).next().html('This field is required');
                            $(this).next().show();
                        } else {
                            $(this).next().html('');
                            $(this).next().hide();
                            if ($(this).hasClass('phone_validator') && $(this).val() != '') {
                                var ph_pattern = /\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g;
                                if (!ph_pattern.test($(this).val())) {
                                    error = 1;
                                    console.log($(this).attr('name'));
                                    $(this).next().html('Please enter a valid phone no.');
                                    $(this).next().show();
                                } else {
                                    $(this).next().html('');
                                    $(this).next().hide();
                                }
                            }
                        }
                    } else {
                        if ($(this).val() == '') {
                            error = 1;
                            $(this).next().html('This field is required');
                            $(this).next().show();
                        } else {
                            if (!email_pattern.test($(this).val())) {
                                error = 1;
                                $(this).next().html('Please enter a valid email');
                                $(this).next().show();
                            } else {
                                $(this).next().html('');
                                $(this).next().hide();
                            }
                        }
                    }
                }
            }
        });
        return error;
    }
    function optionSelected(el) {
        var skus = $(el).attr('data-rec');
        var name = $(el).attr('name');
        var type = $(el).attr('type');
        var has_input = $(el).attr('data-has_input');
        var this_value = $(el).val();
        var custom_msg = $(el).attr('data-custom_msg');


 
      
      
        if (skus != "null" && skus != "") {
            if (type != 'checkbox') {
                skin_quiz_recomendation_arr[name] = skus;
              
              if(this_value.includes("##")){
                  var temp_value_arr=this_value.split("##");
                  var temp_option_alphabet=temp_value_arr[0];
                  option_selected_alphabets_rec_arr[temp_option_alphabet]=skus;
                  option_selected_alphabets_arr.push(temp_option_alphabet);
                  if(custom_msg){
                     option_custom_msg_arr[temp_option_alphabet]=custom_msg;

                  }

                
              }
            } else {
                skin_quiz_recomendation_arr[name] = (skin_quiz_recomendation_arr[name]) ? skin_quiz_recomendation_arr[name] + ',' + skus : skus;
                 if(this_value.includes("##")){
                    var temp_value_arr=this_value.split("##");
                    var temp_option_alphabet=temp_value_arr[0];
                    option_selected_alphabets_rec_arr[temp_option_alphabet]=skus;
                    option_selected_alphabets_rec_arr[temp_option_alphabet] = (option_selected_alphabets_rec_arr[temp_option_alphabet]) ? option_selected_alphabets_rec_arr[temp_option_alphabet] + ',' + skus : skus;
                    option_selected_alphabets_arr.push(temp_option_alphabet);
                 }
          }
            skin_quiz_recomendation.push(skus);
        }


        console.log('option_selected_alphabets_arr',option_selected_alphabets_arr);
        console.log('option_selected_alphabets_rec_arr',option_selected_alphabets_rec_arr);

        //   var most_selected_aphabet= calculateElementFrequency(option_selected_alphabets_arr);
        // console.log('most_selected_aphabet',most_selected_aphabet);


        skin_quiz_recomendation_sku = Object.values(skin_quiz_recomendation_arr);
        skin_quiz_recomendation_sku = skin_quiz_recomendation_sku.toString();
        skin_quiz_recomendation_sku = skin_quiz_recomendation_sku.split(",");
        skin_quiz_recomendation_sku = new Set(skin_quiz_recomendation_sku);
        skin_quiz_recomendation_sku = [...skin_quiz_recomendation_sku];


        var err = 0;
        if (has_input == 1) {
            err = 1;
            $(el).parent().parent().find('.other_option_input').show();
            $(el).parent().parent().find('.other_option_input').val('');
            $(el).parent().parent().parent().find('.next-button').attr('disabled', true);
            if (type == 'checkbox') {
                var ischecked = $(el).is(':checked');
                if (!ischecked) {
                    $(el).parent().parent().find('.other_option_input').hide();
                    err = 0;
                }
            }
        } else {
            err = 0;
            if (type !== 'checkbox') {
                $(el).parent().parent().parent().find('.other_option_input').hide();
                $(el).parent().parent().parent().find('.other_option_input').val('');
                if ($(el).parent().parent().parent().find('.other_option_input').length > 0) {
                    $(el).parent().parent().parent().find('.other_option_input').val(this_value)
                }
            }
        }
        if (type == 'checkbox') {
            if ($('input[name="' + name + '"]:checked').length == 0) {
                err = 1;
                $(el).parent().parent().parent().find('.next-button').attr('disabled', true);
            } else {
                err = 0;
                if ($(el).parent().parent().parent().find('.other_option_input').length > 0 && $(el).parent().parent().parent().find('.other_option_input').is(":visible")) {
                    if ($(el).parent().parent().parent().find('.other_option_input').val() == '') {
                        err = 1;
                        $(el).parent().parent().parent().find('.next-button').attr('disabled', true);
                    } else {
                        err = 0;
                    }
                } else {
                    err = 0;
                }
            }
        }
        if (err == 0) {
            $(el).parent().parent().parent().find('.next-button').removeAttr('disabled');
        }
    }
    function goToNextQuestion(el) {
        $(el).parent().parent().hide();
        $(el).parent().parent().next('.question_wrap').show();

        var bg_image=$(el).parent().parent().next('.question_wrap').attr('data-bg');
        var bg_img_url='https://cdn.shopify.com/s/files/1/0550/8926/6768/files/'+bg_image;
        $('.quiz_section_show_image').css('background-image', 'url(' + bg_img_url + ')');
       adjust_height();

    }
    function goToPrevQuestion(el) {
        $(el).parent().parent().hide();
        $(el).parent().parent().prev('.question_wrap').show();

        var bg_image=$(el).parent().parent().prev('.question_wrap').attr('data-bg');
        var bg_img_url='https://cdn.shopify.com/s/files/1/0550/8926/6768/files/'+bg_image;
         $('.quiz_section_show_image').css('background-image', 'url(' + bg_img_url + ')');
      adjust_height();


    }
    function loadNailQuiz(questions_data) {
        var html = '';
        var q_length = questions_data.questions.length;
                    initial_bg_image=questions_data.questions[0].image;

        $.map(questions_data.questions, function (question_data_single, index) {
            var hide_style = '';
            if (index !== 0) {
                hide_style = 'style="display:none;"';
            } else {
                hide_style = '';
            }
            var question_single_html = '<div data-bg="'+question_data_single.image+'"  data-qid="' + question_data_single.id + '" class="question_wrap"' + hide_style + '>';
            var highlight_html = (question_data_single.tip != '' && question_data_single.tip != null) ? '<div class="highlight_outer d-flex a-i-c "><span class=" highlight_img_holder" ><img alt="icon" src="https://cdn.shopify.com/s/files/1/0550/8926/6768/files/light_bulb.png?v=1717581715"/></span><span>' + question_data_single.tip + '</span></div>' : '';
            question_single_html += '<div class="question_pagination_wrap"><span class="question_wrap_text">' + question_data_single.text + '</span><span class="quiz_question_number">' + parseInt(index + 1) + '/' + q_length + '</span>' + '</div>';
            options_html_singe = '';
            $.map(question_data_single.options, function (option_data, index_option) {
                var is_arr = (question_data_single.type == 'checkbox') ? '[]' : '';
                var other_input = (parseInt(option_data.has_input) == 1) ? '<input placeholder="Please specify" onKeyup="validateOtherInput(this)" class="  other_option_input" style="display:none;" type="text" name="' + question_data_single.slug + is_arr + '" />' : '';
                options_html_singe += '<div class="option_wrap' + ((option_data.has_input) ? ' has_input ' : '') + '"> <label><input data-custom_msg="'+option_data.option_msg+'" data-rec="' + option_data.variant_ids + '" onChange="optionSelected(this)" class="input_option" data-has_input="' + option_data.has_input + '" name="' + question_data_single.slug + is_arr + '" value="' + option_data.value + '" type="' + question_data_single.type + '"/>' + option_data.label + '</label>' + other_input + '</div>';
            })
            var prev_btn_html = (index > 0) ? '<button onClick="goToPrevQuestion(this)" type="button" class="btn previous-button" style="display: block;" data-prev="">Prev</button>' : '';
            var next_btn = (parseInt(index + 1) === parseInt(q_length)) ? 'Submit' : 'Next';
            var next_btn_click_attr = (parseInt(index + 1) === parseInt(q_length)) ? 'showContactInfoForm(this)' : 'goToNextQuestion(this)';
            var next_btn_html = '<button  onClick="' + next_btn_click_attr + '" disabled type="button" class="btn ml-10  next-button" style="display: block;" data-next="">' + next_btn + '</button>';
            question_single_html += options_html_singe + '<div class="button_wrap_quiz">' + prev_btn_html + next_btn_html + '</div>' + highlight_html + '</div>';
            html += question_single_html;
        })
        
        var custom_session_id='';
        var input_session_id = '<input type="hidden" name="session_id" value="' + custom_session_id + '"/>';
        // $('.quiz_wrap').html('<form id="skin_quiz" name="skin_quiz">' + input_session_id + html + '</form>');
              $('.quiz_wrap').html('<form id="skin_quiz" name="skin_quiz">' + html + '</form>');
       nailQuiz(initial_bg_image);
    }
    function fetchNailQuizDataFromDB() {
      
        $('.quiz_wrap').html('<div class="ta-c">Loading Questions.....<div/>');
       
        $.ajax({
            type: 'POST',
            url: "https://www.dermelect.store/requests.php",
            data: {
                action: "get-nail-quiz-data"
            },
            dataType: 'json',
            success: function (response) {
                loadNailQuiz(response);
            }
        });
    }
    function validateOtherInput(el) {
        if ($(el).val() != '') {
            $(el).parent().parent().find('.next-button').removeAttr('disabled');
        } else {
            $(el).parent().parent().find('.next-button').attr('disabled', true);
        }
    }
    async function fetchSkinRecomendation(recommendation_data) {
        rec_html = '';
        current_rec_html = '';
        var currency_symbol = getCurrentCurrency();
        for (k = 0; k < recommendation_data.length; ++k) {
            var current_handle = recommendation_data[k];

            await fetch('/products/' + current_handle + '.js')
                .then(res => res.json())
                .then(response => {
                    if (response.available) {
                        var btn_attr = '';
                        var this_variant_data = (response.variants[0].available) ? response.variants[0] : response.variants[1];
                        var featured_img_link = response.featured_image;
                        var variant_param = '';
                        if (current_handle == 'smooth-supple-lip-mask-melt') {
                            this_variant_data = response.variants[1];
                            variant_param = '?variant=';
                            featured_img_link = (this_variant_data.featured_image.src != '') ? this_variant_data.featured_image.src : response.featured_image;
                            featured_img_link += '&width=1200';
                        }
                        var variantId = this_variant_data.id;
                        var variantSku = this_variant_data.sku;
                        var variantPrice = this_variant_data.price;
                        var btn_text_label = "{{ 'products.product.add_to_cart' | t }}";
                        var disabled_att_btn = '';
                        var available_class = 'pr_is_available';
                        if (!response.available) {
                            btn_text_label = "{{ 'products.product.sold_out' | t }}";
                            disabled_att_btn = ' disabled ';
                            available_class = '';
                        }
                        btn_attr = 'onclick = "customAddToCart(' + variantId + ',1,' + '\'recommendation\',this,' + response.id + ',' + '\'' + response.title + '\'' + ', ' + '\'' + response.vendor + '\'' + ', ' + '\'' + response.vendor + '\'' + ', ' + '\'' + variantSku + '\'' + ', \'USD\',' + variantPrice + ')"';
                        current_rec_html = current_rec_html + '<div data-vid="' + variantId + '" data-rec=' + variantSku + ' class="recomendation_item" ><a aria-label="' + response.title + '" href="/products/' + response.handle + '"><span><img alt="icon"  height="auto" src="' + featured_img_link + '" />';
                        current_rec_html = current_rec_html + '<div class="product-item__text ta-c "> <h4 class=" ff-body product-item__product-title fs-body-60 text_left"> <span class="d-flex j-c-b">';
                        current_rec_html = current_rec_html + '<span tooltip="' + response.title + '"  class=" ">' + truncateText(response.title) + ' </span>';
                        current_rec_html = current_rec_html + '<span class="product-item__price text_right"><span class="product-item__price">' + currency_symbol + (variantPrice * 0.01) + '</span></span>';
                        current_rec_html = current_rec_html + '</span></h4></div>';
                        current_rec_html = current_rec_html + '</span></a><button ' + disabled_att_btn + ' name="add" type="button" ' + btn_attr + '  class="' + available_class + '  cmn_add_btn show-product-add-to-cart recomendation_item_btn   text_left btn btn--x-small  btn--tertiary product-form__cart-submit " ><span data-add-to-cart-text >' + btn_text_label + '</span><div class="btn__loading-wrap"><div class="btn__loading-bar"></div></div></button></div>';
                    }
                });
        }
        rec_html = rec_html + current_rec_html;
     }
    function showContactInfoForm(el) {
        $('.quiz_wrap').hide();
        // if ($('.footer__parent').hasClass('quiz_section_show_image')) {
        //     $('.footer__parent').removeClass('quiz_section_show_image');
        // }

        if ($('#shopify-section-template--15305229402192__main').hasClass('quiz_section_show_image')) {
          $('.quiz_section_show_image').css('background-image', 'none');
                $('#shopify-section-template--15305229402192__main').removeClass('quiz_section_show_image');
            }

        $('.recommendations_loader').show();
        setTimeout(function () {
            $('.loader_analyse').hide();
            $('.loader_fetch').show();
        }, 2500);
        setTimeout(function () {
            $('.recommendations_loader').hide();
            $('.loader_fetch').hide();
            $('.contact_info_div.pre_quiz_steps').show();
        }, 3500);
    }
    function submitQuiz(el) {
        var err = validateSkinQuizContact(el);
        if (err == 0) {
            $(el).html('fetching recommendation...');
            $(el).attr('disabled', true);
            var queryString = $('#skin_quiz').serialize();
            var response_data = new FormData($('form#skin_quiz')[0]);
            var name = $('.input#response_name').val();
            var lastname = $('.input#response_lastname').val();
            var email = $('.input#response_email').val();
            var phone = $('.input#response_phone').val();
            response_data.append('action', "submit-quiz-response");
            response_data.append('name', name);
            response_data.append('lastname', lastname);
            response_data.append('phone', phone);
            response_data.append('email', email);
            response_data.append('recomended_sku', skin_quiz_recomendation_sku.toString());
            response_data.append('accept_marketing', 0);
            response_data.append('quiz_type', 2);

            if ($('.contact-form-checkbox__checkbox#response_accept_marketing:checked').length > 0) {
                response_data.append('accept_marketing', 1);
            }

              // var get_custom_session_id = get_CookieVal('custom_session_id');
              // if (!get_custom_session_id) {
              //     var custom_session_id = Date.now();
              //     set_CookieVal('custom_session_id', custom_session_id, 1440);
              // } else {
              //     custom_session_id = get_custom_session_id;
              // }
               var custom_session_id = Date.now();
               set_CookieVal('custom_session_id', custom_session_id, 1440);

              
              response_data.append('session_id', custom_session_id);


              
              console.log('option_selected_alphabets_arr',option_selected_alphabets_arr);
              console.log('option_selected_alphabets_rec_arr',option_selected_alphabets_rec_arr);

              var most_frequent_option_arr= modeArray(option_selected_alphabets_arr);
              // console.log('most_selected_aphabet',most_selected_aphabet);
              console.log('most_frequent_option_arr',most_frequent_option_arr);
              // console.log('rec',option_selected_alphabets_rec_arr[most_selected_aphabet]);

              var current_recomended_list='';
             var final_custom_msg='';
              most_frequent_option_arr.forEach((element, index) => { 
                  

                  current_recomended_list=current_recomended_list+','+ option_selected_alphabets_rec_arr[element];
                final_custom_msg=(option_custom_msg_arr[element])?option_custom_msg_arr[element]:'';
              });

             current_recomended_list = current_recomended_list.replace(/,\s*$/, "");
             console.log('current_recomended_list',current_recomended_list);
             console.log('option_custom_msg_arr',option_custom_msg_arr)
             

                // return false;
          
              $.ajax({
                type: 'POST',
                url: "https://www.dermelect.store/requests.php",
                data: response_data,
                cache: false,
                processData: false,
                contentType: false,
                dataType: 'json',
                success: function (response) {
                    $(el).attr('disabled', false);
                    $('.recommendations_wrap .featured-collection-grid__product').each(function () {
                        if (skin_quiz_recomendation_sku.includes($(this).attr('data-rec'))) {
                            $(this).show();
                        } else {
                            $(this).hide();
                        }
                    });
                    var quiz_common_div_subtext = $('.quiz_common_div_subtext').html();
                    quiz_common_div_subtext = quiz_common_div_subtext.replace("[Insert_Name]", name);
                     var return_html='<br/>';
                      if($(window).width() < 600){
                         
                        return_html='<br><br/>';
                      }
                    $('.quiz_common_div_subtext').html(quiz_common_div_subtext+return_html+final_custom_msg);
                    $('.recommendations_wrap').addClass('rec_showing');
                     $(".featured-collection-grid__product").each(function() {
                       var current_pr_sku=$(this).attr('data-rec');
                        
                       if(!current_recomended_list.includes(current_pr_sku)){
                        $(this).hide();
                       }
                    });
                  
                    $('.recommendations_wrap').show();
                    $('.recommendations_heading').show();
                    $('.contact_info_div.pre_quiz_steps').hide();

                    document.body.scrollTop = 0;  
                    document.documentElement.scrollTop = 0;
                }
            });
        }
    }
    function insertSKUAddedTOCart(sku) {
        var get_custom_session_id = get_CookieVal('custom_session_id');
        if (get_custom_session_id) {
            $.ajax({
                type: 'POST',
                url: "https://www.dermelect.store/requests.php",
                data: {
                    action: "insert-sku-added-to-cart",
                    sku: sku, session_id: get_custom_session_id
                },
                dataType: 'json',
                success: function (response) {
                }
            });
        }
    }
    function customAddAllToCart(el,page_type='') {
        var add_arr = [];
        $(el).addClass('loading');
        $(".featured-collection-grid__product").each(function () {
            if ($(this).css('display') != 'none') {
                var vid = $(this).attr('data-vid');
                var item = { 'id': parseInt(vid), 'quantity': 1 };
                if(page_type=='quiz'){
                 item.properties={ "custom_session_id": get_CookieVal('custom_session_id') }
                }
                add_arr.push(item);
            }
        });
        let formData = { 'items': add_arr };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        }).then(response => {
            $(el).removeClass('loading'); loadAjaxCart();
        }).catch((error) => {
            console.error('Error:', error);
        });
    }
    function adjust_height(){
      var docHeight = (document.height !== undefined) ? document.height : document.body.offsetHeight;
      var head = document.querySelector('header').offsetHeight;
      var blackHead = document.querySelector('.announcement-bar__outer-wrapper').offsetHeight;
      var totalHead = head + blackHead;
      var ftr = document.querySelector('.footer__parent').offsetHeight;
      var headFtr = totalHead + ftr;
      var restHeight = docHeight - headFtr;
      document.querySelector('.quiz_section').style.minHeight = restHeight + "px";
     }

$(window).resize(function(){
adjust_height();
});

$(document).ready(function () {
fetchNailQuizDataFromDB();
});